import { makeStyles } from "tss-react/mui";
import { MiSectionHeader } from "@miplatform/components";
import { Box, Typography } from "@mui/material";

export function ActivityTimeline({
  showHeader = true,
  showDate = true,
  data,
  renderDetail,
  disableSpacing = false,
}) {
  const { classes } = useStyles();

  return (
    <Box className={!disableSpacing && classes.container}>
      {showHeader && <MiSectionHeader title="Activity" />}
      {Object.entries(data).map(([dateKey, timeGroups]) => (
        <Box key={dateKey} className={!disableSpacing && classes.section}>
          {showDate && (
            <Typography variant="body1" fontWeight={600} gutterBottom>
              {dateKey}
            </Typography>
          )}
          {Object.entries(timeGroups).map(([time, activities]) => (
            <Box key={time} className={classes.timelineRow}>
              <Box className={classes.timelineColumn}>
                <Typography variant="body2" className={classes.time}>
                  {time}
                </Typography>

                <Box className={classes.lineWrapper}>
                  <Box className={classes.verticalLine} />
                </Box>
              </Box>

              <Box className={classes.contentColumn}>
                {Array.isArray(activities) &&
                  activities.map((activity) => (
                    <Box key={activity.id} mb={2}>
                      {renderDetail(activity)}
                    </Box>
                  ))}
              </Box>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: 8,
    margin: 8,
  },
  section: {
    paddingLeft: 12,
    marginBottom: 16,
  },
  timelineRow: {
    display: "flex",
    alignItems: "stretch",
  },
  timelineColumn: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    minWidth: 64,
    flexShrink: 0,
  },
  time: {
    marginBottom: 4,
    textAlign: "right",
  },
  lineWrapper: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
  },
  verticalLine: {
    width: "1px",
    marginLeft: "auto",
    backgroundColor: theme.palette.grey[400],
    height: "calc(100% - 12px)",
  },
  contentColumn: {
    flex: 1,
    paddingLeft: 8,
  },
}));
